// extracted by mini-css-extract-plugin
export default {"root":"_KNUbA71oTlUhtqEQapX","container":"_h06aNV1dQ1ZikzN_A_k","content":"A4tGhBWhFSKbDipOMAzv","footer":"TMSfBw1lBdFjeQxv_Kw4"};